import * as React from 'react'

import listItem from '@/svg/list-item'
import ReactDOMServer from 'react-dom/server'
import { motion } from 'framer-motion'
import { fadeIn } from '@/lib/utils/framer-motion-config'

type ProseType = {
    html: string
    classes?: string
    h4?: boolean
    transition?: boolean
}

const Prose: React.FunctionComponent<ProseType> = ({ html, classes, h4, transition = false }) => {
    const replacedLiElement = `<li><span class=\"absolute left-0 top-1\">${ReactDOMServer.renderToString(
        listItem()
    )}</span>`
    html = html.replace(/<li>/g, replacedLiElement)

    const proseClasses = classes
        ? classes
        : `space-y-7 md:space-y-8 prose-li:flex prose-a:underline prose-a:font-semibold hover:prose-a:no-underline prose-li:relative prose-li:items-baseline prose-li:before:mr-5 prose-h2:font-black prose-h2:text-3xl md:prose:h2-text-5xl prose-h3:font-black prose-ul:!mt-4 ${
              h4
                  ? 'prose-h3:text-md md:prose-h3:text-xl md:prose-h3:leading-[28px]'
                  : 'prose-h3:text-xl prose-h3:leading-[28px] lg:prose-h3:text-3xl lg:prose-h3:leading-[34px]'
          } prose-h4:text-md md:prose-h4:text-xl md:prose-h4:leading-[28px] prose-h4:font-black prose-p:text-base md:prose-p:text-md prose-ul:space-y-3 md:prose-ul:space-y-4`

    return (
        <>
            {!transition ? (
                <div className={proseClasses} dangerouslySetInnerHTML={{ __html: html }} />
            ) : (
                <motion.div
                    {...fadeIn}
                    className={proseClasses}
                    dangerouslySetInnerHTML={{ __html: html }}
                />
            )}
        </>
    )
}

export default Prose
